<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <img src="assets/images/PanadolLogo1x.png" class="header-logo" />
        </td>
        <td class="header-title">
          <strong>Efficacy of Paracetamol in kids vs. Comparators</strong>
        </td>
      </tr>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="table-container" style="width:100%;visibility: hidden;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 62px;vertical-align: top;position: relative;left: 4px;">
            <div class="row scrollable" style="display: flex;">
              <div class="left-header" style="z-index: 78;">
                <div class="bg-blue row-1"></div>
                <div class="bg-blue row-2" style="height:135px;">Placebo</div>
                <div class="bg-blue row-3" style="height:82px;">Ibuprofen</div>
              </div>
            </div>
          </td>
          <td style="vertical-align:top;">
            <!-- scrollable right side content -->
            <div class="right-side" style="width:100%;">
              <div class="top-header" style="table-layout:fixed;width:100%">
                <div class="row scrollable" style="display: flex;">

                  <div id="parent-div-2" class="column">
                    <div class="row-1">Fever</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Temple)">Temple, 2013;</a> <br />
                        <a (click)="open(Temple)">Wong, 2001;</a>
                      </strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Kokki)">Kokki, 2010;</a> <br />
                        <a (click)="open(Walson)">Walson, 1992;</a> <br />
                        <a (click)="open(Celebi)">Celebi, 2009;</a> <br />
                        <a (click)="open(Sullivan)">Sullivan, 2011;</a> <br />
                        <a (click)="open(Autret)">Autret-Leca, 2007;</a>
                      </strong>
                    </div>
                  </div>

                  <div id="parent-div-3" class="column">
                    <div class="row-1">Headache/ <br />
                      migraine
                    </div>
                    <div class="bg-green table-text-color row-2"></div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Gallelli)">Gallelli, 2014;</a> <br />
                        <a (click)="open(Hamalainen)">Hamalainen, 1997;</a>
                      </strong>
                    </div>
                  </div>

                  <div id="parent-div-4" class="column">
                    <div class="row-1"> Musculoskeletal Pain <br />
                      (Sprains, Strains & <br />
                      Fractures)
                    </div>
                    <div class="bg-green table-text-color row-2"></div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Shepherd)">Shepherd, 2009</a> <br />
                      </strong>
                      (acute limb fracture)
                    </div>
                  </div>

                  <div id="parent-div-5" class="column">
                    <div class="row-1">Pain (general)</div>
                    <div class="bg-green table-text-color row-2"></div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Perrott)">Perrott, 2004</a>
                      </strong>
                    </div>
                  </div>

                  <div id="parent-div-6" class="column">
                    <div class="row-1">Sore throat pain<br />
                      (tonsillitis/<br />
                      pharyngitis)
                    </div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong><a (click)="open(Ruperto)">Ruperto, 2011</a></strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Schachtel)">Schachtel, 1993;</a> <br />
                        <a (click)="open(Bertin)">Bertin, 1991;</a> <br />
                      </strong>
                      European Society <br />
                      for Clinical <br />
                      Microbiology and <br />
                      Infections Diseases <br />
                      <strong><a (click)="open(Pelucchi)">(Pelucchi, 2012)</a></strong>
                    </div>
                  </div>

                  <div id="parent-div-7" class="column">
                    <div class="row-1">Ear related pain<br />
                      (acute otitis media)</div>
                    <div class="bg-green table-text-color row-2"></div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      Several guidelines <br />
                      recommend the <br />
                      use of analgesia <br />
                      in managing <br />
                      ear-related pain <br />
                      in children.*
                    </div>
                  </div>

                  <div id="parent-div-8" class="column">
                    <div class="row-1">Dental Pain</div>
                    <div class="bg-green table-text-color row-2"></div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      American Academy <br />
                      of Pediatrics, 2018, <br />
                      Canadian Dental <br />
                      Association, 2016
                    </div>
                  </div>

                  <div id="parent-div-9" class="column">
                    <div class="row-1">
                      Fever due to<br />
                      dengue/malaria/<br />
                      chikungunya/Zika
                    </div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      (recommended <br />
                      by various health <br />
                      authorities- CDC, <br />
                      WHO, PAHO as <br />
                      initial choice)
                    </div>
                    <div class="row-3 bg-grey table-text-color center-align">
                      Should be avoided <br />
                      to reduce the risk <br />
                      of increased <br />
                      bleeding (WHO).
                    </div>
                  </div>

                  <div id="parent-div-10" class="column">
                    <div class="row-1">
                      Pain and Fever<br />
                      post vaccination
                    </div>
                    <div class="bg-green table-text-color row-2">
                      <br /><br /><br />
                      <strong><a (click)="open(Jackson)">Jackson, 2011</a></strong>
                    </div>
                    <div class="row-3 bg-grey table-text-color center-align">
                      No comparative <br />
                      studies available
                    </div>
                  </div>

                  <div id="parent-div-11" class="column">
                    <div class="row-1">
                      Fever associated<br />
                      with infection
                    </div>
                    <div class="bg-green table-text-color row-2">
                      <br /><br /><br />
                      CDC, 2016/2019 <br />
                      (PAHO/WHO, 2016
                    </div>
                    <div class="row-3 bg-grey table-text-color center-align">
                      No comparative <br />
                      studies available
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div class="row" style="margin-top:10px;">
  <div class="col-12" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <strong>*NICE guidelines:</strong> Offer regular doses of paracetamol or ibuprofen for pain, using the right
    dose for the age or weight of the child at the right time, and maximum doses for severe pain.
  </div>
</div>

<div class="row" style="margin-top:10px;">
  <div class="col-lg-7" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <b>Instructions</b><br />
    Click on the study number or the author name to see the study details and summary.
  </div>
  <div class="col-lg-5">
    <div style="float: right;">
      <div class="legend-icon bg-green" (click)="active = 1" (mouseover)="active = 1" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 1">
          <img class="popup-panadol-green" />
        </div>
      </div>
      <div class="legend-icon bg-yellow" (click)="active = 2" (mouseover)="active = 2" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 2">
          <img class="popup-panadol-yellow" />
        </div>
      </div>
      <!-- <div class="legend-icon bg-pink" (click)="active = 3" (mouseover)="active = 3" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 3">
          <img class="popup-panadol-pink" />
        </div>
      </div> -->
      <div class="legend-icon bg-grey" (click)="active = 4" (mouseover)="active = 4" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 4">
          <img class="popup-panadol-grey" />
        </div>
      </div>
    </div>

  </div>
</div>


<ng-template #Ruperto let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Paracetamol - Safe and effective analgesic treatment for
          children with sore throat
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Randomized placebo-controlled trial evaluating the analgesic effect and tolerability of single-dose
                  paracetamol
                  syrup 12mg/kg compared to placebo and ketoprofen lysine salt 40mg in 97 children 6-12 yrs of age with
                  pharyngotonsillitis cared by family pediatricians.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Primary endpoint was the Sum of Pain Intensity Differences (SPID) of the CSTP Intensity scale by the
                  child.
                </p>
              </td>
            </tr>
          </table>

        </div>
      </div>
      <div class="row" style="padding: 15px 0px 30px 0px;">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 20px;font-weight:bold">
          Paracetamol was significantly more effective than placebo in the SPID<br />
          of children and parents (p &lt; 0.05), but not in the SPID

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Ruperto N, Carozzino L, Jamone R, et al. Italian journal of pediatrics. 2011 Sep 29;37(1):1.
    </p>
  </div>
</ng-template>


<ng-template #Jackson let-modal>
  <div class="modal-header">
    <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 30px;line-height: 36px;"
      id="GhoshTitle">
      <strong>
        Paracetamol - Effective relief<br /> (fever and fussiness
        after vaccination)
      </strong>
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true"><img src="assets/images/close.png"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;padding-bottom:20px;">
          Paracetamol/Acetaminophen (APAP) may reduce the risk of post-vaccination fever and fussiness.
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  A temperature =38°C was recorded for 14% (25/176) of children randomized to APAP compared with 22%
                  (37/176) of those randomized to placebo but that difference was not statistically significant
                  (relative risk
                  [RR], 0.63; 95% CI, 0.40–1.01).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Children randomized to APAP were less likely to be reported as being much more fussy than usual (10%
                  vs
                  24%) (RR, 0.42; 95% CI, 0.25–0.70) or to have the treatment assignment unblinded (3% vs 9%) (RR, 0.31;
                  95% CI,<br /> 0.11–0.83) than those randomized to placebo.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  In age-stratified analyses, among children = 24 weeks of age, there was a significantly lower risk of
                  temperature = 38°C in the APAP group (13% vs. 25%; p = 0.03).
                </p>
              </td>
            </tr>
          </table>

        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Jackson LA, Peterson D, Dunn J, Hambidge SJ, Dunstan M, et al. PLOS ONE, 2011 6(6): e20102.
      doi:10.1371/journal.pone.0020102
    </p>
  </div>
</ng-template>

<ng-template #Kokki let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids <strong>
          - comparable reduction in fever over time
          with Paracetamol, ibuprofen and ketoprofen
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">

      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Two prospective, randomized, double-blind, double-dummy, repeated-dose, multicentre, phase III
                  studies with two parallel groups in each study were conducted in primary-care outpatient clinics.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Children aged 6 months to 6 years presenting with a febrile condition and an oral body temperature
                  of &gt; or =38.8 degrees C or rectal temperature of &gt; or =39 degrees C were eligible for inclusion.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Patients were randomized to receive either ketoprofen syrup 0.5 mg/kg, ibuprofen suspension
                  5 mg/kg or paracetamol suspension 15 mg/kg every 6 hours by the oral route.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  The primary outcome measure was the change in temperature at 3 hours (H<sub>3</sub>), compared
                  with baseline (H<sub>O</sub>).
                </p>
              </td>
            </tr>
          </table>

        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:bold;padding-bottom:20px;">
          All three treatments provided similar mean maximum decreases of
          1.4-1.5 degrees C in body temperature at H<sub>3</sub> compared with H<sub>O</sub>.
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Kokki H, Kokki M. <i>Clinical drug investigation</i>. 2010 Jun 1;30(6):375-86.
    </p>
  </div>
</ng-template>

<ng-template #Walson let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids - <strong>Paracetamol equivalent to ibuprofen at<br /> reducing fever</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;padding-bottom:20px;">
          Randomised, double-blind, multi-dose, parallel-group, variable-duration (24–48 hours) study in febrile
          children
          aged 6 months to 11 years and 7 months (N=64) who received Panadol 15 mg/kg (elixir)
          or ibuprofen 2.5/5/10 mg/kg (liquid) every 6 hours for 24–48 hours.
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 13px;color: #124982;line-height: 18px;font-weight:normal;">
          <p style="font-weight:bold;margin-bottom: 0px;">
            Panadol 15 mg/kg and ibuprofen 10 mg/kg
            showed comparable efficacy over
            48 hours post-dose
          </p><br />
          <img class="img-fluid" src="assets/images/panadol-kids/page-45.png" />
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 13px;color: #124982;line-height: 18px;font-weight:normal;">
          <p style="font-weight:bold;">
            Safety of Panadol in children
          </p>
          <p>
            Panadol was well tolerated by most children
          </p>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Adverse events (AE) excluding those occurring before
                  the study and those considered only remotely related
                  to study treatments are shown
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  No AEs of greater than moderate severity were reported
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Four patients withdrew from the study due to AEs
                </p>
              </td>
            </tr>
          </table>

        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Walson PD et al. Am J Dis Child 1992;146:626–632.
    </p>
  </div>
</ng-template>


<ng-template #Celebi let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids <strong>
          - Comparable reduction in fever
          over time with Paracetamol, ibuprofen and ketoprofen
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">

      <div class="row">

        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Randomised, parallel-group study in febrile children
                  aged 1 to 14 years (N=301) who received Paracetamol
                  15 mg/kg (N=112), ibuprofen 10 mg/kg (N=84) or
                  ketoprofen (N=105).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Fever was measured using a tympanic thermometer
                  with measurements taken at 0, 30, 60, 120 minutes
                  and 4−6 hours
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  All study treatments significantly lowered fever vs.
                  baseline at 30, 60 and 120 minutes (p&lt;0.05). The effect was maintained at 4−6 hours.
                </p>
              </td>
            </tr>
          </table>

        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;">
          <img class="img-fluid" src="assets/images/panadol-kids/ketoprofen.png">
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Celebi S et al. Indian J Pediatr 2009;76(3):287-291.
    </p>
  </div>
</ng-template>


<ng-template #Sullivan let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>Paracetamol <span style="font-weight:normal;">is a</span> first-line antipyretic therapy in
          children</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:bold;">
          Typical antipyretic effect of Paracetamol and ibuprofen<sup>1</sup>
        </div>
      </div>
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 12px;font-weight:normal;">
          Current evidence suggests that there is no substantial difference in the safety and effectiveness of
          Paracetamol
          and ibuprofen in the care of a generally healthy child with fever.<sup>1</sup>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 colxl-4 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;font-weight:bold;">
          Most guidelines recommend either
          Paracetamol or ibuprofen as first-line
          treatments for fever, but NICE reinforces
          that “paracetamol (acetaminophen) has
          a longer-established safety record”.<sup>2</sup>
        </div>
        <div class="col-lg-8 col-md-8 colxl-8 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;padding-top: 5px;">
          <table class="table-width-ld">
            <!-- <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol-kids/38-Slide.png">
              </td>
            </tr> -->
            <tr>
              <th
                style="border: 1px solid #15717E;background-color: #15717E; font-family: OpenSansRegular;font-size: 11px;color: #ffffff;line-height: 16px;font-weight:normal;text-align: left;padding: 10px 2px;">
                Variable
              </th>
              <th
                style="border: 1px solid #15717E;background-color: #15717E;font-family: OpenSansRegular;font-size: 11px;color: #ffffff;line-height: 16px;font-weight:normal;text-align: left;padding: 10px 2px;">
                Paracetamol
              </th>
              <th
                style="border: 1px solid #15717E;background-color: #15717E;font-family: OpenSansRegular;font-size: 11px;color: #ffffff;line-height: 16px;font-weight:normal;text-align: left;padding: 10px 2px;">
                Ibuprofen
              </th>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Decline in temperature
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                1-2<sup>&#176;</sup>C
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                1-2<sup>&#176;</sup>C
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED; font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Time to onset
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                &#60;1 h
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                &#60;1 h
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Time to peat effect
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                3-4 h
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                3-4 h
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Dose
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                15 mg/kg
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                10 mg/kg
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Maximum daily dose
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                90 mg/kg
              </td>
              <td
                style="border: 1px solid #dddddd;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                40 mg/kg
              </td>
            </tr>
            <tr>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                Lowest age
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                1 month
              </td>
              <td
                style="border: 1px solid #dddddd;background-color: #F0EFED;font-family: OpenSansRegular;font-size: 11px;color: #000000;line-height: 16px;font-weight:normal;">
                3 months
              </td>
            </tr>
          </table>

        </div>
        <table style="height: 30px;"></table>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Sullivan JE <i>et al. Paediatrics</i> 2011:127:580 <br />
      2. National Institute for Health and Care Excellence. Fever in under 5s: assessment and initial management. 2013.
      https://www.nice.org.uk/guidance/cg160 (accessed March 2016).
    </p>
  </div>
</ng-template>

<ng-template #Autret let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids - <strong>Paracetamol equivalent to ibuprofen at<br /> reducing fever</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:normal;">
          A randomised, single-dose, double-blind study in children aged 3 months to 12 years (N=301) with non-serious
          fever
          who received paracetamol or ibuprofen
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 colxl-4 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:bold;">
          Paracteamol and ibuprofen demonstrated
          equivalent antipyretic efficacy from
          30 min to 8 hours <br />post-dose
        </div>
        <div class="col-lg-8 col-md-8 colxl-8 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:normal;">
          <img src="assets/images/panadol-kids/autret.png" style="width:80%" />

        </div>

      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Autret-Leca E et al. Curr Med Res Opin 2007;23:2205–2211.
    </p>
  </div>
</ng-template>

<ng-template #Gallelli let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids
        <strong>- Paracetamol significantly decreases
          the pain intensity in children with migraine</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:normal;">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Evaluated 160 children 5-16 yrs of age with at least 4 migraines per month primary migraine attacks.
                  Migraine pain endurance and monthly frequency were similar in the 4 groups.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Both APAP 15 mg/kg and ibuprofen 10 mg/kg induced a significant decrease in pain intensity (p&lt;
                  0.01),
                  without a time-dependent correlation, but did not modify its frequency.
                </p>
              </td>
            </tr>

          </table>
        </div>
      </div>


    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Gallelli L, Avenoso T, Falcone D, et al. Headache. 2014; 54:313-24.
    </p>
  </div>
</ng-template>

<ng-template #Hamalainen let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids
        <strong>
          - Paracetamol is effective and well
          tolerated for moderate or severe acute attacks
          of migraine in children
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:normal;">
          <table class="hamalainen-table-1">
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Evaluated eighty-eight children, aged 4.0 to 15.8 yrs, with migraine in a double-blind crossover
                  study.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Three attacks per child were treated in random order with single oral doses of 15 mg/kg paracetamol,
                  10 mg/kg Ibuprofen,
                  and placebo at home.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Primary end point, Alleviation = reduction in severe or moderate headache (grade =3 on a scale of 1 to
                  5) by at least two grades
                  after 2 hrs, was reached twice as often with Paracetamol (54%) and three times as often with Ibuprofen
                  (68%) as with placebo.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  (In the intent-to-treat analysis, children improved twice as often with Ibuprofen(68%) and Paracetamol
                  as with placebo(37%).
                </p>
              </td>
            </tr>

          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;font-weight:bold;padding-bottom:10px;">
                Paracetamol had a faster onset than Ibuprofen.
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  At 1-hr paracetamol was significantly better
                  than placebo at relieving pain (OR 3.9, 95%
                  CI 1.4-12.0) and making children pain free
                  (3.3, 95% CI 1.0-11.1).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  There was no significant difference between
                  paracetamol and Ibuprofen at 1 hr.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  In the intent-to-treat analysis paracetamol
                  was twice as effective as placebo at 1 and
                  2 hrs and there was no clear difference
                  between the two active drugs.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 2px;">
                  Paracetamol had a faster onset than
                  Ibuprofen
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 10px;color: #124982;line-height: 15px;font-weight:normal;font-style:italic;">
          <strong>Table 1</strong> Number of children responding to single oral doses of 10 mg/kg ibuprofen,
          15 mg/kg acetaminophen, and placebo in the treatment of migraine attacks<br /><br />
          <img class="img-fluid" src="assets/images/panadol-kids/page-52.png" />
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Hamalainen ML, Hoppu K, Valkeila E, Santavuori P. Neurology 1997; 48(1):103-107.
    </p>
  </div>
</ng-template>

<ng-template #Shepherd let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids
        <strong>
          - Paracetamol as effective as ibuprofen in
          pediatric patients discharged with acute limb fractures
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row" style="margin-bottom:20px">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 14px;font-weight:normal;">
          <table class="hamalainen-table-1">
            <tr>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  Prospective, randomized controlled study in 94 subjects conducted in a children’s ED.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  Children aged 5–14 yrs with an acute limb fracture were randomized to be prescribed paracetamol 15
                  mg/kg/dose
                  every 4 h or ibuprofen 10 mg/kg/dose every 8 h.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:bold">
          <p style="margin-bottom: 8px;">
            Primary objective:
          </p>
          <p style="font-size: 12px;margin-bottom: 8px;">
            To determine whether Ibuprofen provides better
            analgesia than paracetamol for pediatric patients
            discharged with acute limb fractures.
          </p>
          <table style="font-weight:normal;">
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  Child-reported pain did not differ significantly
                  between the paracetamol and ibuprofen groups
                  (mean pain score paracetamol 2.8 [95% CI 2.4–3.4]
                  vs 2.7 [95% CI 2.1–3.3], p = 0.73).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  Parent-reported sleep quality did not differ
                  between the two groups (p = 0.78).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  Child reported pain scores decreased over the
                  48 h of measurement (p &lt; 0.0001).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 2px;">
                  There were no significant differences in side-effects
                  detected between the two groups.
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;font-weight:normal;font-style:italic;">
          <img class="img-fluid" src="assets/images/panadol-kids/page-53.png">
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Shepherd M, Aickin R. Emergency Medicine Australasia. 2009 Dec 1;21(6):484-90.
    </p>
  </div>
</ng-template>


<ng-template #Perrott let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids
        <strong>
          - Paracetamol as effective as ibuprofen
          for relieving moderate to severe pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">


      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:bold">

          <table style="font-weight:normal;">
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  Meta-analysis that evaluated seventeen blinded, RCCT receiving either APAP 7-15mg/kg or
                  Ibuprofen 4-10 mg/kg.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  The authors concluded that in children, single doses of Ibuprofen (4-10 mg/kg) and APAP (7-15 mg/kg)
                  have similar efficacy for relieving moderate to severe pain, and similar safety as analgesics or
                  antipyretics.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Perrott DA, Piira T, Goodenough B, Champion GD. Archives of pediatrics & adolescent medicine. 2004 Jun
      1;158(6):521-6.
    </p>
  </div>
</ng-template>


<ng-template #Pelucchi let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Guideline for management of acute sore throat.
          European Society for Clinical Microbiology and
          Infectious Diseases
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">


      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12"
          style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;font-weight:bold">

          <table style="font-weight:normal;">
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  Either ibuprofen or APAP are recommended for relief of acute sore throat symptoms.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  A systematic review and six randomized-controlled trials found that NSAIDs and APAP are more effective
                  than placebo for reducing
                  acute sore throat symptoms in adults. Ibuprofen and diclofenac are slightly more effective than APAP
                  for pain relief. APAP and Ibuprofen
                  were the safest.
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  In a large RCT, Ibuprofen, when used in accordance with the usual contraindications, was as well
                  tolerated as APAP for the short-term
                  treatment of the pain of cold and flu symptoms and of sore throat in adults.
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  No trials were found comparing Ibuprofen and diclofenac.
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  A systematic review showed that Ibuprofen and APAP are more effective than placebo for reducing acute
                  sore throat symptoms
                  in children.
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;">
                  •&nbsp;
                </p>
              </td>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin-bottom: 8px;">
                  Another systematic review assessed the efficacy and safety of single doses of Ibuprofen and APAP for
                  short-term treatment of children’s
                  pain or fever. The results did not indicate any difference between the drugs in analgesic efficacy or
                  safety.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Pelucchi C, Grigoryan L, Galeone C, Esposito S, Huovinen P, Little P, Verheij T. Guideline for the management of
      acute sore throat. Clinical microbiology and infection. 2012 Apr 1;18(s1):1-28
    </p>
  </div>
</ng-template>


<ng-template #Temple let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol kids -
        <strong>Paracetamol starts to work on fever in<br /> 15 minutes<sup style="line-height: 0px;">1-4</sup></strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="padding-bottom: 10px; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
          The 15-minute claim is based on data from three studies<sup style="line-height: 0px;">1-3</sup> with
          additional data from a paper by Temple, 2013.<sup style="line-height: 0px;">4</sup>
        </div>
        <div class="col-lg-8 col-md-8 colxl-8 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;padding-bottom: 8px;">
                Wong et al 2001, conducted a randomised, double-blind, multicenter
                trial involving a total of 628 febrile children aged 6 months to 6 years.
                Each child’s temperature was measured at baseline and then again
                15 minutes, 30 minutes, 45 minutes, 1 hour, 1.5 hours and then hourly
                out to 6 hours after a single dose of study medication.<sup style="line-height: 0px; ">1</sup> There was
                a
                downward slope in temperature at the 15 minute timepoint (Figure)
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;padding-bottom: 8px;">
                <strong>Temple 2013</strong> paper reviewed unpublished and published data to
                provide additional support to strengthen this claim.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;padding-bottom: 8px;">
                Three out of 13 unpublished studies (10-15 mg/kg paracetamol)
                measured temperature reduction at 15 minutes as the first timepoint;
                all 3 were in patients with high-grade fever at baseline (mean 39.2°C)
                reported a reduction in temperature from baseline (mean reduction 0.13°C).
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;padding-bottom: 8px;">
                Out of 40 published studies reported in this review, 8 studies had
                measured temperature reduction at 15 minutes as the first timepoint;
                all of which showed a reduction from baseline (range 0.15-0.33°C)
                despite a range of paracetamol doses (6-15 mg/kg).
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-4 col-md-4 colxl-4 col-sm-12">
          <table style="border: 1px solid #124982; padding: 10px;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol-kids/panadolchild15min.png">
              </td>
            </tr>
          </table>

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Wong A, Sibbald A, Ferrero F, <i>et al. Clin Pediatr (Phila)</i>. 2001;40:313-24.<br />
      2. Mahar AF, Allen SJ, Milligan P, <i>et al. Clin Pediatr (Phila)</i>. 1994;33:227-31.<br />
      3. Senel S, Erkek N, Karacan CD. <i>Indian J Pediatr</i>. 2012;79:213-7.<br />
      4. Temple AR, Temple BR, Kuffner EK. <i>Clin Ther</i>. 2013;35:1361-75.e1-45
    </p>
  </div>
</ng-template>

<ng-template #Schachtel let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>Children’s assessment of Paracetamol shows sustained
          analgesic efficacy</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12"
          style="padding-bottom: 10px; font-family: OpenSansRegular;font-size: 15px;font-weight: bold; color: #124982;line-height: 19px;">
          Randomised, single-dose, double-blind, placebo-controlled study in children aged 2–12 years with acute sore
          throat treated with Paracetamol, ibuprofen, or placebo
        </div>
        <div class="col-lg-7 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td
                style="padding-bottom: 10px; font-family: OpenSansRegular;font-size: 12px; color: #124982;line-height: 15px;">
                Paracetamol showed significant pain relief versus placebo from 1 hour
                post-dose, and sustained until 4 hours after dosing
              </td>
            </tr>
          </table>
          <table style="border: 1px solid #124982;margin-left: 35px;margin-top: 8px;margin-bottom: 8px;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol-kids/childsustain-2x.png"
                  style="height: auto;width: 305px;">
              </td>
            </tr>
          </table>

        </div>
        <div class="col-lg-5 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td
                style="padding-bottom: 10px; font-weight: bold; font-family: OpenSansRegular;font-size: 12px; color: #124982;line-height: 15px;">
                Early onset and long-lasting effective pain relief
                with Paracetamol
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="padding-bottom: 10px; font-family: OpenSansRegular;font-size: 12px; color: #124982;line-height: 15px;">
                Both Paracetamol and ibuprofen provided early relief of pain
                The total pain relief reported over the 6-hour study period
                was statistically significant and clinically meaningful
              </td>
            </tr>
          </table>
          <table style="border: 1px solid #124982; padding: 10px;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol-kids/panadollonglasting.png">
              </td>
            </tr>
          </table>

        </div>
        <div class="col-lg-7 col-md-12 colxl-12 col-sm-12" style="padding-top: 10px;">
          <table>
            <tr>
              <td
                style="padding-bottom: 10px; font-weight: bold; font-family: OpenSansRegular;font-size: 12px; color: #124982;line-height: 15px;">
                Paracetamol is well tolerated
              </td>
            </tr>
            <table>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  No treatment-related AEs were observed
                </td>
              </tr>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  There was one AE in a 12-year-old child, who immediately vomited the study medication
                  (ibuprofen)
                </td>
              </tr>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  No other AEs were reported
                </td>
              </tr>
            </table>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Schachtel BP, Thoden WR.<i>Clin Pharmacol Ther</i>1993;53:593–601.
    </p>
  </div>
</ng-template>


<ng-template #Bertin let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Paracetamol - Safe and effective analgesic treatment
          for children with sore throat
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 15px;"></table>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;">
            <strong>Schachtel, 1993<sup style="line-height: 0px; font-size: 8px;">1</sup></strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 5px;"></table>
            <table>
              <tr>
                <td
                  style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  Single-dose placebo-controlled clinical trial in children aged 2-12 yrs with a sore throat received
                  paracetamol
                  (APAP) 15mg/kg, Ibuprofen 10mg/kg or placebo over 6 hrs.
                </td>
              </tr>
              <tr>
                <td
                  style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  The children, parents and pediatrician all rated Ibuprofen and APAP as effective compared to placebo
                  at<br />
                  most post treatment time points and overall.
                </td>
              </tr>
              <tr>
                <td
                  style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  Both APAP and Ibuprofen significantly reduced oral temperature in children with baseline temperatures
                  >99°F.
                </td>
              </tr>
            </table>
            <table style="height: 25px;"></table>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;">
            <strong>Bertin, 1991<sup style="line-height: 0px; font-size: 8px;">2</sup></strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 8px;"></table>
            <table>
              <tr>
                <td
                  style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  Sore throat (tonsillitis/pharyngitis): paracetamol and Ibuprofen to be superior to placebo but no
                  difference<br />
                  from each other.
                </td>
              </tr>
              <tr>
                <td
                  style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  •&nbsp;
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                  These results were similar to those in (Schachtel, 1993), despite the latter having used a higher dose
                  of<br />
                  paracetamol (10 mg/kg vs 15 mg/kg).
                </td>
              </tr>
            </table>
            <table style="height: 15px;"></table>
          </div>

          <table style="height: 15px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px;">
      1. Schachtel BP, Thoden WR.. Clin Pharmacol Ther 1993; 53(5):593-601.<br />
      2. Bertin L, Pons G, d'Athis P, et al. J Pediatr. 1991;119:811-4.
    </p>
  </div>
</ng-template>
